<template>
  <div>
    <div class="flex-col">
      <label for="username">{{ "login.form.email" | translate }}</label>
      <input
        type="text"
        name="username"
        id="username"
        v-model="input.username"
        class="form-input"
      />
      <label for="password">{{ "login.form.password" | translate }}</label>
      <input
        type="password"
        name="password"
        id="password"
        v-model="input.password"
        class="form-input"
      />
      <a v-on:click="forgotPasswordClicked">
        {{ "login.forgot_password" | translate }}
      </a>
      <button
        class="button salmon"
        type="button"
        :disabled="!fields_valid"
        v-on:click="loginClicked"
      >
        {{ "login.form.login" | translate }}
      </button>
      <div v-if="checkout">
        <h1>{{ "login.titles.guest_user" | translate }}</h1>
        <input
          type="text"
          name="email"
          v-model="guestUser.email"
          :placeholder="'login.guest_user.form.email' | translate"
        />
        <button type="button" @click="createGuestUserClicked">
          {{ "login.guest_user.register" | translate }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { authMixin } from "../mixins";
import { createGuestUser } from "../services/api";

const field_validations = {
  username: email => !!email,
  password: password => !!password
};
export default {
  name: "Login",
  data() {
    return {
      input: {
        username: "",
        password: ""
      },
      checkout: this.$router.currentRoute.query.checkout,
      guestUser: {
        email: null
      }
    };
  },
  computed: {
    fields_valid() {
      return Object.keys(this.input).every(key =>
        field_validations[key](this.input[key])
      );
    }
  },
  mixins: [authMixin],
  methods: {
    async loginClicked(event) {
      event && event.preventDefault();
      const username = this.input.username;
      const password = this.input.password;
      if (username != "" && password != "") {
        const res = await this.login(username, password);
        if (!(res instanceof Error)) {
          this.$bvToast.toast("Authenticated", {
            title: "Success",
            autoHideDelay: 5000,
            variant: "success"
          });
          this.$router.replace({
            path: this.$router.currentRoute.query.returnPath || "/"
          });
        } else {
          // console.log(res);
          // console.log("The username and / or password is incorrect");
        }
      } else {
        // console.log("A username and password must be present");
      }
    },
    forgotPasswordClicked(event) {
      event && event.preventDefault();
      this.$router.push({ name: "ForgotPassword" });
    },
    async createGuestUserClicked(event) {
      event && event.preventDefault();
      const email = this.guestUser.email;
      if (email) {
        const verifyRoute = window.location.origin + "/checkout";
        const cartId = this.$router.currentRoute.query.cart_id;
        const res = await createGuestUser(email, verifyRoute, cartId);
        if (!(res instanceof Error)) {
          this.$bvToast.toast("Authenticated", {
            title: "Success",
            autoHideDelay: 5000,
            variant: "success"
          });
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
a {
  margin-bottom: 1rem;
  text-decoration: underline;

  &:hover {
    color: $brand-salmon;
    text-decoration: underline;
  }
}

p {
  text-align: center;
  white-space: pre-line;
  font-weight: 600;
}

.button {
  margin-bottom: 1rem;
  box-shadow: none;
}
</style>
